// =============================================================================
// Util: Fechas de calendario (fecha-local.util.ts)
// Los formularios de facturación guardan la fecha como texto 'YYYY-MM-DD' (lo que
// va a ARCA). JavaScript lee ese formato como medianoche UTC, que en Argentina
// (UTC−3) es el día anterior a las 21:00: el selector mostraba un día menos.
// Una fecha sin hora es un día de calendario: se lee en la hora local.
// =============================================================================

const SOLO_FECHA = /^(\d{4})-(\d{2})-(\d{2})$/;

/**
 * Convierte 'YYYY-MM-DD' en ese mismo día a las 00:00 hora local.
 * Devuelve null si el texto no es una fecha sin hora o si el día no existe (ej.: 2026-02-30).
 */
export function fechaIsoALocal(valor: string): Date | null {
  const m = SOLO_FECHA.exec(valor.trim());
  if (!m) return null;
  const [anio, mes, dia] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const fecha = new Date(anio, mes - 1, dia);
  const existe = fecha.getFullYear() === anio && fecha.getMonth() === mes - 1 && fecha.getDate() === dia;
  return existe ? fecha : null;
}
